module.exports = __webpack_public_path__ + "images/e-mailc3a00046d704a1fdab64f408e7b0df53.png";